import Vue from 'vue'
import VueRouter from 'vue-router'
import BlogListView from "@/views/BlogListView.vue";
import BlogPageView from "@/views/BlogPageView.vue";
import NotFoundPage from "@/views/NotFoundPage.vue";
import AdminLoginView from "@/views/admin/AdminLoginView.vue";
import AdminBlogListView from "@/views/admin/AdminBlogListView.vue";
import AdminBlogEditView from "@/views/admin/AdminBlogEditView.vue";
import store from "@/store";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'list',
        component: BlogListView
    },
    {
        path: '/blog/:id',
        name: 'blog',
        component: BlogPageView
    },
    {
        path: '/admin/login',
        name: 'admin-login',
        component: AdminLoginView
    },
    {
        path: '/admin',
        name: 'admin-blog-list',
        component: AdminBlogListView,
        meta: {requiresAuth: true}
    },
    {
        path: '/admin/new',
        name: 'admin-blog-new',
        component: AdminBlogEditView,
        meta: {requiresAuth: true}
    },
    {
        path: '/admin/edit/:id',
        name: 'admin-blog-edit',
        component: AdminBlogEditView,
        meta: {requiresAuth: true}
    },
    {
        path: '/404',
        name: 'not-found',
        component: NotFoundPage
    },
    {
        path: '*',
        redirect: '/404'
    }
]


const router = new VueRouter({
    mode: 'history',
    routes
})
router.beforeEach((to, from, next) => {
    // if path is /blog/:id, check if id is a valid number
    if (to.name === 'blog') {
        // console.log('blog page id:', to.params.id)
        const id = to.params.id
        if (!id || isNaN(Number(id)) || parseInt(id) <= 0) {
            next('/404');
            return;
        }
    }
    // admin/** 除了登入頁本身，其餘都要求已登入（有本機存的 JWT）
    if (to.matched.some(record => record.meta.requiresAuth) && !store.getters['Auth/isLoggedIn']) {
        next({name: 'admin-login', query: {redirect: to.fullPath}});
        return;
    }

    // 已經 login 的使用者，不能再去登入頁
    if (to.name === 'admin-login' && store.getters['Auth/isLoggedIn']) {
        next({name: 'admin-blog-list'});
        return;
    }
    next();
})

export default router
